import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonComponent } from '../skeleton/skeleton.component';
import { WidgetSkeletonBlock } from './widget-skeleton.model';

/**
 * Renders a {@link WidgetSkeletonBlock} list. The one place a widget's loading placeholder is drawn, so
 * the shell showing it while a chunk downloads and the widget showing it while its data loads cannot
 * disagree about what the card looks like.
 */
@Component({
  selector: 'app-widget-skeleton',
  standalone: true,
  imports: [NgTemplateOutlet, SkeletonComponent],
  templateUrl: './widget-skeleton.component.html',
  styleUrl: './widget-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetSkeletonComponent {
  readonly blocks = input.required<WidgetSkeletonBlock[]>();

  /** `@for` needs a concrete list to walk; the counts in the blocks are just numbers. */
  countOf(total: number): number[] {
    return Array.from({ length: Math.max(0, total) }, (_, i) => i);
  }
}
